import { isFunction } from "@visactor/vutils";

export function getMinFontSizeOfEnv() {
    return 12;
}

export const randomHslColor = (min, max) => "hsl(" + (360 * Math.random()).toFixed() + "," + (30 * Math.random() + 70).toFixed() + "%," + (Math.random() * (max - min) + min).toFixed() + "%)";

export function functor(d) {
    return isFunction(d) ? d : function() {
        return d;
    };
}
//# sourceMappingURL=util.js.map